import { Component } from "@angular/core";

@Component({
  styleUrls: ['./logout-success.component.css'],
  templateUrl: './logout-success.component.html',
})
export class LogoutSuccessComponent {

}